import * as React from "react";

import styled, { css } from "styled-components";

const DlWrapper = styled.div`
  margin: 0 -0.5rem;
`;

const Dl = styled.dl`
  display: table;
  width: 100%;
  margin-bottom: 0;
`;

const DlDiv = styled.div`
  display: table-row;
`;

const SharedDtDdStyles = css`
  display: table-cell;
  padding: 0.25rem 0.5rem;
`;

const Dt = styled.dt.attrs({
  className: "text-muted small",
})`
  ${SharedDtDdStyles}
  font-weight: normal;
  width: 1%;
  min-width: 120px;
  text-align: right;
`;

const Dd = styled.dd`
  ${SharedDtDdStyles}
`;

const InlineDt = styled.dt.attrs({
  className: "small",
})`
  display: inline;
  &:after {
    content: ": ";
  }
`;

const InlineDd = styled.dd.attrs({
  className: "small",
})`
  display: inline;
`;

interface DefinitionListItemProps {
  term: React.ReactNode;
  definition: React.ReactNode;
}

export const DefinitionListTableItem: React.FC<DefinitionListItemProps> = ({
  term,
  definition,
}) => {
  return (
    <DlDiv>
      <Dt>{term}</Dt>
      <Dd>{definition}</Dd>
    </DlDiv>
  );
};

export const DefinitionListTable: React.FC<{}> = ({ children }) => {
  return (
    <DlWrapper>
      <Dl>{children}</Dl>
    </DlWrapper>
  );
};

export const DefinitionListInlineItem: React.FC<DefinitionListItemProps> = ({
  term,
  definition,
}) => {
  return (
    <div>
      <InlineDt>{term}</InlineDt>
      <InlineDd>{definition}</InlineDd>
    </div>
  );
};

export const DefinitionListInline: React.FC<{}> = ({ children }) => {
  return <dl>{children}</dl>;
};
